import React from 'react'
import datepipeModel from '../models/datepipemodel'

const GroupHistory = ({ data = [] }: any) => {
  if (!data || data.length === 0) {
    return (
      <div className="text-gray-500 text-sm py-4">
        No history available for the past {localStorage.getItem('connectMeetHistory') || 6} months.
      </div>
    )
  }

  // Collapse rows with the same eventId so each event appears once, with all
  // members the user met across any ConnectMeet group in that event.
  const byEvent = new Map<string, { event: any; members: Map<string, any> }>()
  for (const ele of data) {
    const event = ele?.eventsDetails?.[0]
    const eventId = String(event?._id || ele?.eventId || Math.random())
    if (!byEvent.has(eventId)) byEvent.set(eventId, { event, members: new Map() })
    const entry = byEvent.get(eventId)!
    const members = Array.isArray(ele?.membersDetails) ? ele.membersDetails : []
    for (const m of members) {
      const key = String(m?._id || m?.email || m?.fullName || Math.random())
      if (!entry.members.has(key)) entry.members.set(key, m)
    }
  }

  const grouped = Array.from(byEvent.values())
    .map(g => ({ event: g.event, members: Array.from(g.members.values()) }))
    .sort((a, b) => {
      const da = a.event?.date ? new Date(a.event.date).getTime() : 0
      const db = b.event?.date ? new Date(b.event.date).getTime() : 0
      return db - da
    })

  return (
    <div className="flex flex-col gap-3 max-h-[60vh] overflow-y-auto pr-2">
      {grouped.map((g, idx) => (
        <div key={idx} className="border border-gray-200 rounded-lg p-3 bg-orange-50">
          <div className="mb-2">
            <h4 className="text-sm font-semibold text-[#2b2b2b] capitalize">
              {g.event?.title || 'Event'}
            </h4>
            {g.event?.date && (
              <p className="text-xs text-gray-600">{datepipeModel.datetime(g.event.date)}</p>
            )}
          </div>
          {g.members.length > 0 && (
            <ul className="flex flex-col gap-1 mt-2">
              {g.members.map((m: any, i: number) => (
                <li key={i} className="text-xs text-gray-700 capitalize flex items-center gap-2">
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-gray-400" />
                  {m?.fullName || m?.email || 'Member'}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  )
}

export default GroupHistory
